

<div class="max-page-width">
  <div class="modify-pickup">
    <div class=" row m-0">

      <div class="col-lg-5 col-md-6 left-modal-side">
        <div class="left-modal-side-padding">
          <h3 mat-dialog-title>{{ 'UpdateBookingDate' | translate }}</h3>
          <p>{{ 'Updatepickupandreturndatesasneeded' | translate }}</p>

          <div  [ngClass]="{ 'HideDiv': needPayment&&true }" >
            <div class="search-Form-modal mt-4">
              <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
                <!--Pickup-->
                <section class="pickup ">
                  <div class="row">
                    <label class="col-lg-3 col-md-12">{{ 'Pickup' | translate }}</label>
                    <div class="col-lg-9 col-md-12">
                      <div class="form-group">
                        <div class="input-group">
                          <span class="input-group-prepend disable-text">
                            <span class="input-group-text disable-text">
                              <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
                            </span>
                          </span>
                          <input formControlName="PickUpLocation" class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.PickUpLocation.errors }" disabled />
                        </div>
                        <div *ngIf="submitted && f.PickUpLocation.errors" class="invalid-feedback">
                          <div *ngIf="f.PickUpLocation.errors.required"></div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 pr-md-0">
                          <div class="form-group ">
                            <div class="pick-up-date is-invalid">
                              <mat-form-field class="form-control" appearance="none">
                                <mat-datepicker-toggle matPrefix [for]="PickUpDate"></mat-datepicker-toggle>
                                <mat-datepicker #PickUpDate></mat-datepicker>
                                <input  readonly placeholder=" " formControlName="PickUpDate" matInput
                                  [min]="minPickUpDate" [matDatepicker]="PickUpDate" (click)="PickUpDate.open()"
                                  (dateInput)="addEvent(1,'input', $event)" (dateChange)="addEvent(1,'change', $event)">
                              </mat-form-field>

                            </div>
                            <div *ngIf="submitted && f.PickUpDate.errors!=null" class="invalid-feedback">
                              <div *ngIf="f.PickUpDate.errors.required"></div>
                              <div *ngIf="f.PickUpDate.errors.matDatepickerMin!=null">{{'TheSelectedDateShouldBeGreaterThanTheCurrentDate' |translate}}</div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <div class="pick-up-time">
                              <fa-icon class="time-icon" [icon]="faClock"></fa-icon>
                              <input [placeholder]="minTime" formControlName="PickUpTime" id="pickUpTime" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <!--Drop-off-->
                <section class="drop-off ">
                  <div class="row">
                    <label class="col-lg-3 col-md-12">{{ 'Return' | translate }}</label>
                    <div class="col-lg-9 col-md-12">
                      <div class="form-group ">
                        <div class="input-group">
                          <span class="input-group-prepend disable-text">
                            <span class="input-group-text disable-text">
                              <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
                            </span>
                          </span>
                          <mat-select panelClass="select-modify" class="form-control select" formControlName="DropUpLocation"
                            [ngClass]="{'is-invalid':searchForm.get('DropUpLocation').touched && searchForm.get('DropUpLocation').invalid}"
                            required data-placeholder="Select" disabled>
                            <mat-option *ngFor="let dropUpLocation of dropUpLocations"
                              [value]="dropUpLocation.returnAgencyID">
                              {{dropUpLocation.agencyReturnLocationName | translate}}</mat-option>
                          </mat-select>
                        </div>
                      </div>
                      <!--       <div class="form-group">
                        <div class="input-group">
                            <span class="input-group-prepend">
                                <span class="input-group-text">
                                    <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
                                </span>
                            </span> -
                            <mat-form-field appearance="none">
                              <mat-select  [(value)]="selectedDropUpLocation">
                                <mat-option *ngFor="let dropUpLocation of dropUpLocations" [value]="dropUpLocation.returnAgencyID">
                                  {{dropUpLocation.agencyReturnLocationName}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="submitted && f.DropUpLocation.errors" class="invalid-feedback">
                            <div *ngIf="f.DropUpLocation.errors.required"></div>
                        </div>
                      </div> -->
                      <div class="row">
                        <div class="col-md-6 pr-md-0">
                          <div class="form-group">
                            <div class="drop-off-date is-invalid">
                              <mat-form-field appearance="none">
                                <mat-datepicker-toggle matPrefix [for]="dropUpDate"></mat-datepicker-toggle>
                                <mat-datepicker #dropUpDate></mat-datepicker>
                                <input readonly placeholder="Sat 25 Jan 2020" formControlName="dropUpDate"
                                  (dateInput)="addEvent(2,'input', $event)"
                                  (dateChange)="addEvent(2,'change', $event);dropUpDate.open()" matInput
                                  [min]="minDropOffDate" [matDatepicker]="dropUpDate" (click)="dropUpDate.open()">
                              </mat-form-field>

                            </div>
                            <div *ngIf="submitted && f.dropUpDate.errors!=null" class="invalid-feedback">
                              <div *ngIf="f.dropUpDate.errors.required"></div>
                              <div *ngIf="f.dropUpDate.errors.matDatepickerMin!=null">{{'TheSelectedDateShouldBeGreaterThanTheCurrentDate' |translate}}</div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <div class="drop-off-time">
                              <fa-icon class="time-icon" [icon]="faClock"></fa-icon>
                              <input placeholder="12:00am" formControlName="dropUpTime" id="dropUpTime" />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="mt-3">
                        <button class="btn default-btn mr-3" mat-button>{{ 'Find' | translate }}</button>
                        <button (click)="cancelClicked()" class="btn default-cancel-btn" mat-button>{{ 'Cancel' | translate }}</button>
                      </div>

                    </div>
                  </div>
                </section>
              </form>
            </div>
            <ng-container *ngIf="submitted">

              <div class="row">
                <div class="col-lg-3 col-md-12">

                </div>
                <div class="col-lg-9 col-md-12">
                  <div *ngIf="success">

                    <div class="success">
                      <div class="border-success-title bg-grey d-flex  mb-3">
                        <div>
                          <mat-icon class="text-blue">insert_emoticon</mat-icon>
                        </div>
                        <div>
                          <p class="ml-3">{{ 'Great' | translate }}</p>
                          <span>{{ 'RentalisAvailable' | translate }}</span>
                        </div>
                      </div>
                      <!-- <div class="text-left">
                      <button (click)="close()" class="btn default-btn mr-3" mat-button>{{ 'CancelChange' | translate }}</button>
                    </div> -->
                    </div>

                    <!--           <div class="border-danger mb-3">
                    <div class="border-danger-title d-flex">
                      <mat-icon>warning</mat-icon>
                      <span>The Following Extra(s) will not be Available</span>
                    </div>
                    <div class="row mt-3" >
                      <div class="col-md-1 text-right mt-1">
                        <mat-slide-toggle disabled></mat-slide-toggle>
                      </div>
                      <div class="col-md-11 pl-0">
                        <div class="d-flex flex-row">
                          <div class="detail-title mr-3 ml-4 mt-1">
                            <mat-icon class="mr-1 detailsIcon" svgIcon="childSeats"></mat-icon>serviceName
                            <span class="detail-price ml-3">5692 $/ DAY</span>
                          </div>
                          <input disabled type="text" class="form-control form-control-number ml-auto" placeholder="0"
                            aria-label="driverInformation" [min]="1">
                        </div>
                      </div>
                    </div>
                  </div> -->
                    <div class="text-left">
                      <button class="btn default-btn mr-3" mat-button (click)="onConfirm()">{{ 'Confirm' | translate
                        }}</button>
                      <button (click)="cancelClicked()" class="btn default-cancel-btn" mat-button>{{ 'Cancel' | translate }}</button>
                    </div>
                  </div>
                </div>
              </div>



              <div class="row">
                <div class="col-lg-3 col-md-12">

                </div>
                <div class="col-lg-9 col-md-12">
                  <div *ngIf="success!=null && !success">
                    <div class="not-available">
                      <div class="border-danger-title bg-grey d-flex  mb-3">
                        <div>
                          <mat-icon>warning</mat-icon>
                        </div>
                        <div>
                          <p class="ml-3">{{ 'Sorry' | translate }}</p>
                          <span>{{ resultMsg | translate }}</span>
                        </div>
                      </div>
                      <!-- <div class="text-left">
                      <button (click)="close()" class="btn default-btn mr-3" mat-button>{{ 'CancelChange' | translate }}</button>
                    </div> -->
                    </div>
                  </div>
                </div>
              </div>



              <div class="row">
                <div class="col-lg-3 col-md-12">

                </div>
                <div class="col-lg-9 col-md-12">
                  <div *ngIf="notAvailable">
                    <div class="not-available">
                      <div class="border-danger-title bg-grey d-flex  mb-3">
                        <div><mat-icon>warning</mat-icon></div>
                        <div *ngIf="notAvailableReason==NotAvailableReasonEnum.NotAvailablePeriod">
                          <p class="ml-3">{{ 'Sorry' | translate }}</p>
                          <span>{{ 'BookedRentalisNotAvailable' | translate }}</span>
                        </div>
                        <div *ngIf="notAvailableReason==NotAvailableReasonEnum.ReturnLocationIsNotAvailable">
                          <p class="ml-3">{{ 'Sorry' | translate }}</p>
                          <span>{{ 'ReturnLocationNotAvailable' | translate }}</span>
                        </div>
                        <div *ngIf="notAvailableReason==NotAvailableReasonEnum.UnavailableAdditional">
                          <p class="ml-3">{{ 'Sorry' | translate }}</p>
                          <span>{{ 'UnavailableAdditional' | translate }}</span>
                          <!-- List of Unavailable Additional-->
                          <div>
                            <span *ngFor="let service of result.lstUnavailableAdditionalServiceReservationCaseModel">{{service.serviceName}} <span *ngIf="service.numberOfUnavailable!=null&&service.numberOfUnavailable>0">({{service.numberOfUnavailable}})</span> </span>
                          </div>

                        </div>
                      </div>
                      <div class="text-left">
                        <button class="btn default-btn mr-3" mat-button (click)="onConfirm()">{{ 'Confirm' | translate}}</button>
                        <button (click)="cancelClicked()"  class="btn default-btn mr-3" mat-button>{{ 'CancelChange' | translate }}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>




            </ng-container>
          </div>



          <payment-edit *ngIf="needPayment" [requiredPayment]="requiredPayment"
            [vehicleReservationCaseResult]="vehicleReservationCaseResult" [objPayment]="objPayment"
            (onCancel)="changeViewType()"
            ></payment-edit>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 modal-card ">
        <vehicle-card-for-modal [vehicle]="vehicle"></vehicle-card-for-modal>
      </div>
      <div class="col-lg-4 col-md-12 modify-booking-charge-summary">


          <!--charge summery view-->
          <charge-summary-view-booking [newDurationData]="newDurationData" [viewBookingViewMode]="viewBookingViewMode"></charge-summary-view-booking>
          <!-- <charge-summary></charge-summary> -->

      </div>
    </div>
  </div>
</div>

<simple-notifications></simple-notifications>
